const getters = {
  token: state => state.userInfo.token,
  userInfo: state => state.userInfo,
  path: state => state.sysInfo.path,
  dynamicRouter: state => state.menu.dynamicRouter,
  dynamicLeftMenu: state => state.menu.dynamicLeftMenu,
  factoryCode: state => state.common.factoryCode,
  MK: state => state.common.MK,
  JJFY: state => state.common.JJFY,
  PROJECT: state => state.common.PROJECT,
  PART: state => state.common.PART,
  ARTICLE: state => state.common.ARTICLE,
  LOCATION: state => state.common.LOCATION,
  CASH: state => state.common.CASH,
  WEEK: state => state.common.WEEK,
  EXTRAWORK: state => state.common.EXTRAWORK,
  LEAVEWORK: state => state.common.LEAVEWORK,
  PERSONNELRANK: state => state.common.PERSONNELRANK,
  CUSTOMER: state => state.common.CUSTOMER,
  SUPPLIER: state => state.common.SUPPLIER,
  loginStatus: state => state.common.loginStatus,
  opcity: state => state.common.opcity
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js